var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"active":_vm.showPopup,"title":_vm.popupTitle},on:{"update:active":function($event){_vm.showPopup=$event}}},[_vm._v(_vm._s(_vm.popupContent))])
}
var staticRenderFns = []

export { render, staticRenderFns }